import Delete from "@material-symbols/svg-500/rounded/delete.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const DeleteIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Delete });
	return <Icon />;
};

export default memo(DeleteIcon);
